import { TRoutes } from './const'

/*
 * Der Weg von einer Dashboard-Kachel in die Anforderungsliste.
 *
 * Die Kachel nennt eine Zahl („Neu: 7"); der Klick darauf muss genau diese
 * sieben Zeilen zeigen und nichts daneben. Dafür braucht es zwei Angaben in der
 * Adresszeile — welche Sicht (Reiter) und welcher Status —, und beide Seiten
 * müssen dieselben Wörter dafür verwenden.
 *
 * Deshalb steht der Vertrag hier und nicht in der Kachel: Sonst schriebe das
 * Dashboard `?status=NEW`, die Liste läse `?stufe=` — und der Verweis führte
 * stillschweigend in eine ungefilterte Liste, was schlimmer ist als gar kein
 * Verweis, weil die Zahl daneben dann falsch aussieht.
 *
 * Nur Eintritt, kein Zustand: Die Liste schreibt ihre Filter **nicht** zurück
 * in die Adresszeile. Sie hat mit Sicht, Status, Art, Projekt, Zuweisung,
 * Bundesland, Archiv, Suche und Sortierung neun davon; sie alle zu spiegeln
 * wäre eine eigene Aufgabe (und die Filterleiste UI/FilterPanel kann das
 * bereits für die Ansichten, die sie verwendet).
 */

export const TICKET_LINK_PARAMS = { status: 'status', scope: 'scope', herkunft: 'herkunft' }

const SEPARATOR = ','

/**
 * Adresse der Anforderungsliste mit vorgewähltem Status und/oder Sicht.
 *
 * @param {{ status?: string[]|string, scope?: string, herkunft?: string[]|string }} auswahl
 */
export const ticketListLink = ({ status, scope, herkunft } = {}) => {
	const params = new URLSearchParams()
	const stufen = Array.isArray(status) ? status : status ? [status] : []
	const gruppen = Array.isArray(herkunft) ? herkunft : herkunft ? [herkunft] : []

	if (stufen.length) params.set(TICKET_LINK_PARAMS.status, stufen.join(SEPARATOR))
	if (scope) params.set(TICKET_LINK_PARAMS.scope, scope)
	if (gruppen.length) params.set(TICKET_LINK_PARAMS.herkunft, gruppen.join(SEPARATOR))

	const query = params.toString()
	return query ? `${TRoutes.TICKETS}?${query}` : TRoutes.TICKETS
}

/**
 * Was in der Adresszeile steht, für die Liste gelesen.
 *
 * Unbekannte Werte werden verworfen statt durchgereicht: Ein Tippfehler in der
 * Adresse ergäbe sonst einen Filter auf einen Status, den es nicht gibt — eine
 * leere Liste ohne erkennbaren Grund.
 *
 * @param {string} search Der Teil ab `?`, also `history.location.search`.
 * @param {{ status: string[], scopes: string[], herkunft: string[] }} erlaubt
 */
export const readTicketListParams = (search, erlaubt) => {
	const params = new URLSearchParams(search || '')

	const status = (params.get(TICKET_LINK_PARAMS.status) || '')
		.split(SEPARATOR)
		.filter(wert => erlaubt.status.includes(wert))

	const herkunft = (params.get(TICKET_LINK_PARAMS.herkunft) || '')
		.split(SEPARATOR)
		.filter(wert => (erlaubt.herkunft || []).includes(wert))

	const scope = params.get(TICKET_LINK_PARAMS.scope)

	return {
		status,
		herkunft,
		scope: erlaubt.scopes.includes(scope) ? scope : null
	}
}
